import { keys } from 'ramda';
import { textAlignStyles } from './text';

const textStyles = {
  textAlign: textAlignStyles
};

const textAligns = keys(textAlignStyles);

// See https://stackoverflow.com/questions/55377365/what-does-keyof-typeof-mean-in-typescript
// typeof operator gives you the type of an object
// then keyof operator gives you the literal type union
// derive the types of each property from the implementation
export type TextProps = {
  textAlign?: keyof typeof textAlignStyles;
};

const textInterpolations = {
  textAlign: ({ textAlign }: Pick<TextProps, 'textAlign'>) =>
    textAlign === undefined ? {} : { class: textAlignStyles[textAlign] }
};

export { textAligns, textAlignStyles, textInterpolations, textStyles };
